/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatientJourneyEntry } from './PatientJourneyEntry';
import {
    PatientJourneyEntryFromJSON,
    PatientJourneyEntryFromJSONTyped,
    PatientJourneyEntryToJSON,
    PatientJourneyEntryToJSONTyped,
} from './PatientJourneyEntry';

/**
 * 
 * @export
 * @interface PatientJourney
 */
export interface PatientJourney {
    /**
     * 
     */
    first_name: string | null;
    /**
     * 
     */
    last_name: string | null;
    /**
     * 
     */
    items: Array<PatientJourneyEntry>;
}

/**
 * Check if a given object implements the PatientJourney interface.
 */
export function instanceOfPatientJourney(value: object): value is PatientJourney {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function PatientJourneyFromJSON(json: any): PatientJourney {
    return PatientJourneyFromJSONTyped(json, false);
}

export function PatientJourneyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientJourney {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'items': ((json['items'] as Array<any>).map(PatientJourneyEntryFromJSON)),
    };
}

export function PatientJourneyToJSON(json: any): PatientJourney {
    return PatientJourneyToJSONTyped(json, false);
}

export function PatientJourneyToJSONTyped(value?: PatientJourney | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'items': ((value['items'] as Array<any>).map(PatientJourneyEntryToJSON)),
    };
}

